import { Chip } from '@mui/material';
import {
  AutocompleteInput,
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceInput,
  SelectInput,
  ShowButton,
  TextField,
  TextInput,
} from 'react-admin';
import { FileExportStatusDto } from 'src/dtos';
import { FileExport } from 'src/models';
import { getFileExportStatusTagPalette } from 'src/utils';

import { CancelFileExportButton } from './CancelFileExportButton';
import { DeleteFileExportButton } from './DeleteFileExportButton';
import { DownloadFileExportButton } from './DownloadFileExportButton';

const statusOptions = Object.values(FileExportStatusDto)?.map((key: string) => ({ id: key, name: key }));

export const filterList = [
  <TextInput key='name' label='File Name' source='name' alwaysOn />,
  <ReferenceInput
    key='offerId'
    label='Offer Name'
    source='offerId'
    reference='offers'
    sort={{ field: 'name', order: 'ASC' }}>
    <AutocompleteInput
      label='Offer Name'
      optionText='name'
      fullWidth
      filterToQuery={searchText => ({ name: searchText })}
    />
  </ReferenceInput>,
  <SelectInput
    key='status'
    label='Status'
    source='status'
    fullWidth
    choices={statusOptions}
    optionText={(record: { id: FileExportStatusDto; name: FileExportStatusDto }) => (
      <Chip label={record.name} sx={getFileExportStatusTagPalette(record.name)} />
    )}
  />,
];

export const FileExportList = () => {
  return (
    <List
      title='File Exports'
      sort={{ field: 'createdAt', order: 'DESC' }}
      exporter={false}
      filters={filterList}
      emptyWhileLoading>
      <Datagrid bulkActionButtons={false}>
        <TextField source='id' label='Id' sortable={false} />
        <FunctionField
          label='File Name'
          render={(record: FileExport) => {
            return record.name.concat(record.offer ? ` (${record.offer.name})` : '');
          }}
          sortable={false}
        />
        <FunctionField label='Type' render={(record: FileExport) => record.type.label} sortable={false} />
        <FunctionField
          label='Status'
          render={(record: FileExport) => (
            <Chip label={record.status.label} sx={getFileExportStatusTagPalette(record.status.value)} />
          )}
          sortable={false}
        />
        <FunctionField
          label='Download'
          render={(record: FileExport) => {
            return <DownloadFileExportButton record={record} />;
          }}
          sortable={false}
        />
        <FunctionField
          label='Cancel'
          render={(record: FileExport) => {
            return <CancelFileExportButton record={record} />;
          }}
          sortable={false}
        />
        <FunctionField
          label='Delete'
          render={(record: FileExport) => {
            return <DeleteFileExportButton record={record} />;
          }}
          sortable={false}
        />
        <DateField source='createdAt' label='Created at' showTime sortable={false} />
        <ShowButton label='Show' />
      </Datagrid>
    </List>
  );
};
